import { useEffect, useState } from 'react'
import SearchableSelect from '../../../../../generic/ui/SearchableSelect/SearchableSelect'

export interface ProductGroup {
  GroupID: number
  GroupDesc: string
}

interface Props {
  fileterGoods: ProductGroup[]
  goodsListDefault: any[]
  setGoodsList: (list: any[]) => void
  setFilterToggleStatus: (v: boolean) => void
  setFilterGoodsDefault: (list: any[]) => void
  setFilteredExist: (list: any[]) => void
  setFilterGoodsValue?: (v: string) => void
  setFilterGoodName?: (name: string) => void
  /** True when the customer requires a group to be picked first (no "all" fallback). */
  neededStatus?: boolean
  /** Disables the selector (used when selection should be locked). */
  selectStatus?: boolean
  className?: string
}

const PROMPT_VALUE = '101' // legacy: "בחר קבוצה" sentinel
const ALL_VALUE = '100' // legacy: "כל הקבוצות" sentinel

const ProductGroupSelector: React.FC<Props> = ({
  fileterGoods,
  goodsListDefault,
  setGoodsList,
  setFilterToggleStatus,
  setFilterGoodsDefault,
  setFilteredExist,
  setFilterGoodsValue,
  setFilterGoodName,
  neededStatus = false,
  selectStatus = false,
  className,
}) => {
  const [selected, setSelected] = useState<ProductGroup | null>(null)

  // Apply the goods list side-effect when the selection changes.
  useEffect(() => {
    if (selected === null) {
      if (neededStatus) {
        setGoodsList([])
      } else {
        setGoodsList(goodsListDefault)
        setFilterToggleStatus(false)
      }
      return
    }
    const filtered = (goodsListDefault || []).filter((item: any) =>
      item.GroupArray?.includes(selected.GroupID),
    )
    setGoodsList(filtered)
    setFilterGoodsDefault(filtered)
    setFilteredExist(filtered)
    if (filtered.length > 0) setFilterToggleStatus(true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selected])

  const handleSelect = (group: ProductGroup | null) => {
    setSelected(group)
    if (group === null) {
      setFilterGoodsValue?.(neededStatus ? PROMPT_VALUE : ALL_VALUE)
      setFilterGoodName?.(neededStatus ? 'בחר קבוצה' : 'כל הקבוצות')
    } else {
      setFilterGoodsValue?.(String(group.GroupID))
      setFilterGoodName?.((group.GroupDesc ?? '').trim())
    }
  }

  return (
    <SearchableSelect<ProductGroup>
      className={className}
      items={fileterGoods ?? []}
      value={selected}
      onSelect={handleSelect}
      getKey={(g) => g.GroupID}
      getLabel={(g) => (g.GroupDesc ?? '').trim()}
      placeholder={neededStatus ? 'בחר קבוצה' : 'כל הקבוצות'}
      disabled={selectStatus && neededStatus}
      allowClear={!neededStatus}
      clearLabel='כל הקבוצות'
      emptyLabel='אין קבוצות'
    
    />
  )
}

export default ProductGroupSelector
